import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPoints } from '../components/PainPoints';
import { HealingIngredients } from '../components/HealingIngredients';
import { WhatsInside } from '../components/WhatsInside';
import { Testimonials } from '../components/Testimonials';
import { PricingCTA } from '../components/PricingCTA';
import { FAQ } from '../components/FAQ';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  return <main className="min-h-screen w-full font-sans text-[#5C3D2E] bg-[#FFFDF5]" data-id="element-157">
      <HeroSection data-id="element-158" />
      <PainPoints data-id="element-159" />
      <HealingIngredients data-id="element-160" />
      <WhatsInside data-id="element-161" />
      <Testimonials data-id="element-162" />
      <PricingCTA data-id="element-163" />
      <FAQ data-id="element-164" />
      <SalesFooter data-id="element-165" />
    </main>;
}